RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Shell = window.createMarionetteApp();
    app.name = 'Shell';

    // NOTE Adds show loading method to ALL regions created henceforth
    // since we cheat by augmenting the prototype.

    /**
    * Shows a loading view of an optionally specified type. Uses the Shell default
    * when no type has been specified.
    * @param [loadingViewType]
    */
    Marionette.Region.prototype.showLoading = function (loadingViewType, options) {
        const me = this;
        const LoadingViewType = loadingViewType || app.views.Loading;
        const view = new LoadingViewType(options);
        me.show(view);
    };

    /**
    * Shows an error view of an optionally specified type. Uses the Shell default
    * when no type has been specified.
    * @param [errorViewType]
    */
    Marionette.Region.prototype.showError = function (errorViewType) {

        const me = this;
        const ErrorViewType = errorViewType || app.views.Error;
        const view = new ErrorViewType();
        me.show(view);
    };

    /**
    * Shows a nag view of an optionally specified type. Uses the Shell default
    * when no type has been specified.
    * @param [source]
    * @param [nagViewType]
    */
    Marionette.Region.prototype.showNagWall = function (source, nagViewType) {

        const me = this;
        const NagViewType = nagViewType || RivalIQ.channels.views.Nag;
        const view = new NagViewType({
            source: source
        });
        me.show(view);
    };

    /**
     * Shows the channel wall for a source in an optionally specified size.
     * @param [source]
     * @param [size] (default) 'text' | 'small' | 'large'
     * @param [template] The selector of the template to render.
     */
    Marionette.Region.prototype.showChannelWall = function (source, size, template) {

        const me = this;
        const view = new RivalIQ.channels.views.ChannelWall({
            source: source,
            template: template,
            size: size || 'text'
        });
        me.show(view);
    };

    app.addRegions({
        notificationRegion: '#notification-bar',
        sidebar: '#sidebar-region',
        secondaryNav: 'nav.navbar-white',
        content: '#content-region',
        sectionHeader: '.x-shell-section-header',
        modal: '#shell-modal-region',
        backdrop: '#application-backdrop'
    });

    app.addInitializer(function () {

        RivalIQ.execute('channels:nag');
    });

    app.getPrimaryTitle = function () {
        return app.sectionHeader.currentView.getTitle();
    };

    // TODO this sucks, we should use a more normalized collection / model
    // structure in the shell
    app.getSecondaryTitle = function () {
        return (app.secondaryNavigation ? app.secondaryNavigation.model.get('activeModel').get('name') : null);
    };

    // TODO another one...
    app.getTimePeriod = function () {
        const timeComponent = RivalIQ.apps.Shell.sectionHeader.currentView.model.get('components').timePeriod;
        if (!timeComponent.disabled) {
            return RivalIQ.state.view.get('timePeriod');
        }

        return timeComponent;
    };

    app.isCompanySetFilteringEnabled = function () {
        const companySets = RivalIQ.apps.Shell.sectionHeader.currentView.model.get('components').companySets;
        return !companySets || !companySets.disabled;
    };

    /**
     * Starts the Shell application.
     */
    function start(options) {
        RivalIQ.apps.Shell.start({
            ui: _.get(options, 'showShellUi', true),
            sidebar: RivalIQ.configuration.sidebar.getGlobal()
        });
        RivalIQ.apps.Shell.started = true;
        RivalIQ.apps.Shell.trigger('started');
    }

    // NOTE initializes and starts Shell; created primarily for testing
    app.initializeAndStart = function (options) {
        // NOTE if we haven't yet initialized and settings exist then wait
        if (!RivalIQ.hasInitialized && !options.startWithoutClientSettings) {
            return RivalIQ.once('state:initialized', _.bind(start, null, options));
        }
        start(options);
    };

});
